export default {
  open53(){
    var _53 = $53.createApi();
    _53.push('cmd', 'kfclient');
    _53.push('type', 'popup');      /*popup是浮动窗口，new是新窗口*/
    _53.query();
  }
}



// WEBPACK FOOTER //
// ./src/config/js/open53.js